export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";